import { Component, OnInit, output, OutputEmitterRef } from '@angular/core';
import { TicketBase } from 'src/app/_interfaces/ticket';
import { GeneralService } from 'src/app/_provider/general.service';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';
import { SupportEmployeeService } from 'src/app/_provider/support/support-employee.service';

@Component({
    selector: 'support-ticket-requests',
    templateUrl: './support-ticket-requests.component.html',
    styleUrls: ['./support-ticket-requests.component.scss'],
    standalone: false
})
export class SupportTicketRequestsComponent {

  public ticketClicked: OutputEmitterRef<TicketBase> = output<TicketBase>();
  public tickets: TicketBase[] = [];

  constructor(
    private supportEmployeeSrv: SupportEmployeeService,
    public generalSrv: GeneralService,
    public resizeManager: ResizeManagerService,
  ){}

  public async loadData(){
    this.tickets = []
    if(this.generalSrv.serverVersionGreaterThan("1.15.0")){
      const result = await this.supportEmployeeSrv.getSupportTicketRequests();
      if(result.success) this.tickets = result.data;
    }
  }

}
